function ListBodyEmpty() {
  return (
    <section className="p-[10px] bg-[#fff] shadow-[inset_0_0_3px_1px_#b17640] text-[#b17640]">
      No results found
    </section>
  );
}

export default ListBodyEmpty;
